import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { FragmentNames, SecurityAuthenticationModalLongDescriptionAliases } from '../../codegen';
import { Inject } from '@odinjs/odin';
import { TextEditorAPI } from '@philips-internal/oswald-ui-components';

@Controller({ fragment: FragmentNames.SECURITY_AUTHENTICATION_MODAL_LONG_DESCRIPTION })
export default class SecurityAuthenticationModalLongDescriptionController extends BaseController {

  @Inject(SecurityAuthenticationModalLongDescriptionAliases.TEXT_EDITOR_LONG_DESCRIPTION_MODAL_LONG_DESCRIPTION)
    textEditorAPI!: TextEditorAPI;

  @OnMount({ target: SecurityAuthenticationModalLongDescriptionAliases.TEXT_EDITOR_LONG_DESCRIPTION_MODAL_LONG_DESCRIPTION })
  mountLongText(): void {
    const longMessage = this.context.get('longMessage') as string;
    this.textEditorAPI.setValue(longMessage);
  }
}
